/* Library */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { _handleUserLogin, handleUserLogout } from './../../../Accounts/createAccount/actions';
import commonUtil from '../../../../utils/commonUtil';
import SideScreen from './SideScreen';

const channel = commonUtil.getChannel();

class Banner extends Component {
  constructor(props) {
    super(props);
    this.toggleRegister = this.toggleRegister.bind(this);
    this.firstName = '';
    this.state = {
      showStore: true,
    };
    this.onLoginSuccess = this.onLoginSuccess.bind(this);
    this.redirectPage = this.redirectPage.bind(this);
    this.updateControl = this.updateControl.bind(this);
  }
  populateMainBannerData() {
    if (this.props.banner) {
      return { __html: channel === 'wap' ? this.props.banner.data : this.props.banner.data };
    } return null;
  }
  componentDidMount() {
    this.updateControl();
  }
  updateControl() {
    if (document.querySelector('#loginForm')) {
      ReactDOM.render(<SideScreen user={this.props.user} eventDetail={this.props.eventDetail} _handleUserLogin={this.onLoginSuccess} _handleRedirects={this.redirectPage} lables={this.props.lables} />, document.querySelector('#loginForm'));
    }
  }
  onLoginSuccess(data) {
    this.props._handleUserLogin(data).then(() => { this.updateControl(); });
  }
  onLogoutSuccess(data) {
    this.props.handleUserLogout(data).then(() => { this.updateControl(); });
  }
  redirectPage = (url) => {
    if (url) {
      browserHistory.push(url);
    }
  }
  toggleRegister() {
    this.setState({ showStore: !this.state.showStore });
  }
  render() {
    return (
      <React.Fragment>
        {this.state.showStore}
        <div id="mainBanner" dangerouslySetInnerHTML={this.populateMainBannerData()} />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  eventDetail: state.eventDetail,
});
const matchDispatchToProps = dispatch => bindActionCreators({ _handleUserLogin, handleUserLogout }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(Banner);
